module.exports = __webpack_public_path__ + "img/TOOLING_DT.366be2a7.png";